import {
  faAddressBook,
  faBan,
  faBell,
  faBoxOpen,
  faCircleChevronRight,
  faCopy,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFileWord,
  faGaugeHigh,
  faHandHoldingDollar,
  faHome,
  faKey,
  faPercent,
  faRightFromBracket,
  faRupiahSign,
  faSitemap,
  faUser,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

export default [
  faAddressBook,
  faBan,
  faBell,
  faBoxOpen,
  faCircleChevronRight,
  faCopy,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFileWord,
  faGaugeHigh,
  faHandHoldingDollar,
  faHome,
  faKey,
  faPercent,
  faRightFromBracket,
  faRupiahSign,
  faSitemap,
  faUser,
  faUsers,
];
